// extracted by mini-css-extract-plugin
export var banner = "welcome-module--banner--e37cf";
export var challenge = "welcome-module--challenge--f9a13";
export var change = "welcome-module--change--05b49";
export var develop = "welcome-module--develop--b8cae";
export var diet = "welcome-module--diet--79264";
export var forum = "welcome-module--forum--8044f";
export var list = "welcome-module--list--5eb8f";
export var logoutBox = "welcome-module--logoutBox--83d11";
export var news = "welcome-module--news--3a939";
export var notify = "welcome-module--notify--d77ed";
export var prize = "welcome-module--prize--9687a";
export var title = "welcome-module--title--599da";